module.exports = __webpack_public_path__ + "img/shop03.a3c7e090.jpg";